import { Car, Home, ShoppingCart, Moon, HardHat } from "lucide-react";

export const CONTACT = {
  company: "TIRERA GROUP SARL",
  site: "www.tireragroup.com",
  email: "tireragroup@gmail.com",
  phone: "+223 92 00 10 10",
  whatsapp: "+33 6 67 14 54 86",
  whatsappLink: "https://wa.me/33667145486",
  address: "Bamako, Mali",
  // Informations légales officielles (Certificat d'immatriculation API-Mali)
  legalForm: "SARL",
  manager: "Cheick Oumar TIRERA",
  rccm: "ML.BKO.01.2026.B.4342",
  rccmDate: "21/07/2026",
  nina: "425900105010008F0005N",
  registeredOffice: "Kalabancoura, Commune V, Bamako, Mali",
  legalPhone: "76 38 14 95",
};

export const _APPS = [
  {
    slug: "kago",
    name: "KaGo",
    icon: Car,
    iconImage: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/zq658nev_IMG_2749.png",
    accent: "#EA8C00",
    tint: "#FFF7EC",
    category: "Transport & Mobilité",
    stores: {
      ios: "https://apps.apple.com/fr/app/kago/id6773093017",
      android: "https://play.google.com/store/apps/details?id=app.tirera.kago",
    },
    highlight: { qualifier: "Plus de", step: 10 },
    tagline: "Vos déplacements en toute sécurité — Taxi, VTC, Moto et livraison de colis, partout à Bamako.",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/ppr1ktns_IMG_3123.webp",
    heroImage: "https://static.prod-images.emergentagent.com/jobs/4bc8c93c-fa86-469a-a49a-36eba45f3ee2/images/1d5a143c09848fd81a04f23360d20dbab8852b85d755b5a637534fc261a1fcb3.jpeg",
    screens: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/ppr1ktns_IMG_3123.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/l5gi445v_IMG_3148.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/c8506qmx_IMG_3147.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/56617wwv_IMG_3149.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/3ha2br23_IMG_3150.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/z0wnry8s_IMG_3151.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/a414kapc_IMG_3152.webp",
    ],
    featureShots: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/l5gi445v_IMG_3148.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/c8506qmx_IMG_3147.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/56617wwv_IMG_3149.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/3ha2br23_IMG_3150.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/z0wnry8s_IMG_3151.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/a414kapc_IMG_3152.webp",
    ],
    features: [
      "Transport VTC & Taxi",
      "Course en Moto rapide",
      "Livraison de colis",
      "Chauffeurs professionnels vérifiés",
      "Paiement intégré & sécurisé",
      "Notifications en temps réel",
    ],
    stats: [
      { key: "trips", label: "Trajets effectués" },
      { key: "drivers", label: "Chauffeurs actifs" },
      { key: "deliveries", label: "Livraisons" },
      { key: "users", label: "Utilisateurs" },
    ],
    whatsNew: [
      "Nouvelle option Moto Express pour les courses urgentes",
      "Suivi du chauffeur en direct sur la carte",
      "Paiement mobile money simplifié",
    ],
    faq: [
      { q: "Comment réserver un trajet ?", a: "Ouvrez KaGo, indiquez votre destination, choisissez Taxi, VTC ou Moto puis confirmez. Un chauffeur proche accepte votre course en quelques secondes." },
      { q: "Puis-je envoyer un colis ?", a: "Oui. Sélectionnez « Livraison de colis », renseignez le point de retrait et de dépôt, et un livreur s'en charge immédiatement." },
      { q: "Quels moyens de paiement acceptez-vous ?", a: "Espèces, mobile money et cartes bancaires directement dans l'application." },
    ],
  },
  {
    slug: "maison",
    name: "Une Maison Pour Tous",
    icon: Home,
    iconImage: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/aeoytyzr_IMG_2860.png",
    accent: "#2563EB",
    tint: "#EEF3FE",
    category: "Immobilier",
    stores: {
      ios: "https://apps.apple.com/fr/app/une-maison-pour-tous/id6768791785",
      android: "https://play.google.com/store/apps/details?id=app.emergent.realestateafrica0e48d7eb",
    },
    highlight: { qualifier: "Près de", step: 10 },
    tagline: "Achetez, louez ou vendez facilement vos biens immobiliers en toute confiance.",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/cj642mbx_IMG_3269.webp",
    screens: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/cj642mbx_IMG_3269.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/8ij7qga9_IMG_3154.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/798f0unt_IMG_3155.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/fnxtj2to_IMG_3156.webp",
    ],
    featureShots: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/qy54gbzo_IMG_3153.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/8ij7qga9_IMG_3154.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/qy54gbzo_IMG_3153.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/798f0unt_IMG_3155.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/7mfergbj_IMG_3158.webp",
    ],
    heroImage: "https://static.prod-images.emergentagent.com/jobs/4bc8c93c-fa86-469a-a49a-36eba45f3ee2/images/fd64760f57fc5cec000e7f10a19f7ac68db0ddd699e556046d8a3d66feadefee.jpeg",
    features: [
      "Vente immobilière",
      "Location courte & longue durée",
      "Agences partenaires vérifiées",
      "Publication d'annonces",
      "Recherche avancée par critères",
    ],
    stats: [
      { key: "listings", label: "Annonces publiées" },
      { key: "agencies", label: "Agences partenaires" },
      { key: "users", label: "Utilisateurs" },
    ],
    whatsNew: [
      "Annonces vérifiées avec badge de confiance",
      "Visite virtuelle 360° des biens",
      "Alertes personnalisées sur vos recherches",
    ],
    faq: [
      { q: "Comment publier une annonce ?", a: "Créez votre compte, appuyez sur « Publier », ajoutez photos, prix et description. Votre annonce est vérifiée puis mise en ligne." },
      { q: "Les annonces sont-elles vérifiées ?", a: "Oui, chaque annonce et chaque agence passe par un contrôle avant publication pour garantir votre sécurité." },
      { q: "Puis-je contacter une agence ?", a: "Absolument, vous pouvez discuter directement avec les agences partenaires depuis l'application." },
    ],
  },
  {
    slug: "bon-africain",
    name: "Bon Africain",
    icon: ShoppingCart,
    iconImage: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/5izgl9u4_IMG_2826.png",
    accent: "#16A34A",
    tint: "#EDFBF1",
    category: "Marketplace",
    stores: {
      ios: "https://apps.apple.com/fr/app/bon-africain/id6778730731",
      android: "https://play.google.com/store/apps/details?id=app.emergent.africalistings1e61e7726",
    },
    highlight: { qualifier: "Plus de", step: 10 },
    tagline: "La marketplace africaine pour acheter et vendre en toute simplicité, entre particuliers et professionnels.",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/0312qh7q_IMG_3121.webp",
    screens: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/0312qh7q_IMG_3121.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/pmpflnx3_IMG_3135.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/g0lbcf1a_IMG_3134.webp",
    ],
    featureShots: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/0312qh7q_IMG_3121.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/pmpflnx3_IMG_3135.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/g0lbcf1a_IMG_3134.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/pmpflnx3_IMG_3135.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/g0lbcf1a_IMG_3134.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/0312qh7q_IMG_3121.webp",
    ],
    heroImage: "https://static.prod-images.emergentagent.com/jobs/4bc8c93c-fa86-469a-a49a-36eba45f3ee2/images/c7c93ce7b434f1d9c2f1b6343e5ff43478600a36ff13cab9d61facae97297a36.jpeg",
    features: [
      "Marketplace complète",
      "Petites annonces",
      "Vente entre particuliers & pros",
      "Recherche par catégorie",
      "Chat intégré acheteur-vendeur",
      "Paiements sécurisés",
    ],
    stats: [
      { key: "listings", label: "Annonces en ligne" },
      { key: "transactions", label: "Transactions" },
      { key: "users", label: "Utilisateurs" },
    ],
    whatsNew: [
      "Chat intégré entre acheteurs et vendeurs",
      "Boutiques professionnelles vérifiées",
      "Filtres de recherche par catégorie améliorés",
    ],
    faq: [
      { q: "Est-ce gratuit de vendre ?", a: "La publication d'annonces de base est gratuite. Des options de mise en avant sont disponibles pour plus de visibilité." },
      { q: "Comment contacter un vendeur ?", a: "Utilisez le chat intégré pour discuter directement et convenir des modalités en toute sécurité." },
      { q: "Les paiements sont-ils protégés ?", a: "Oui, notre système de paiement sécurisé protège acheteurs et vendeurs à chaque transaction." },
    ],
  },
  {
    slug: "ctqibla",
    name: "CTQIBLA",
    icon: Moon,
    iconImage: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/jgiqnsnc_IMG_2916.png",
    accent: "#7C3AED",
    tint: "#F5F0FE",
    category: "Services Islamiques",
    stores: {
      ios: "https://apps.apple.com/fr/app/ctqibla/id6768422511",
      android: "https://play.google.com/store/apps/details?id=com.tirera.ctqibla",
    },
    highlight: { qualifier: "Plus de", step: 10 },
    tagline: "Votre compagnon intelligent pour la prière, le Coran et la vie musulmane, incluant les voyages Hajj & Omra.",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/sw99tfq4_3B18F48B-C724-4437-A183-9F2C5ED54DD6.png",
    screens: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/sw99tfq4_3B18F48B-C724-4437-A183-9F2C5ED54DD6.png",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/631ke9jl_IMG_3138.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/ziwiighs_IMG_3127.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/eu73f10w_IMG_3140.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/2mzoxrxl_IMG_3141.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/tbhso8ry_IMG_3128.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/43u71wl6_IMG_3124.webp",
    ],
    featureShots: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/631ke9jl_IMG_3138.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/wx06kan5_IMG_3139.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/eu73f10w_IMG_3140.webp",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/tbhso8ry_IMG_3128.webp",
      [
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/hkrfbwms_IMG_3143.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/883t2rh3_IMG_3174.jpeg",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/dmw1wu8z_IMG_3175.jpeg",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/ea8vthb0_IMG_3173.jpeg",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/s2l3nt83_IMG_3176.jpeg",
      ],
      [
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/pwqxs2ex_IMG_3145.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/1mwdg704_IMG_3165.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/tbrbgg1q_IMG_3166.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/89n1ifj5_IMG_3167.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/5s34aa58_IMG_3169.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/d0ng7rk2_IMG_3170.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/0vuxgezp_IMG_3171.webp",
        "https://customer-assets-cm19k8pv.emergentagent.net/job_tirera-apps/artifacts/nxhm9ff3_IMG_3172.webp",
      ],
    ],
    heroImage: "https://static.prod-images.emergentagent.com/jobs/4bc8c93c-fa86-469a-a49a-36eba45f3ee2/images/b03909a8a9c7fa7133125d2c79e91651db9d1c7ce92db51e2e5bb09aae2ab96b.jpeg",
    features: [
      "Horaires de prière précis",
      "Boussole Qibla & Tasbih",
      "Coran complet & Duas",
      "Calendrier hégirien",
      "Voyages Hajj & Omra",
      "École Coran (10 niveaux) & Académie CTQIBLA",
    ],
    stats: [
      { key: "users", label: "Utilisateurs CTQIBLA" },
      { key: "quran_reads", label: "Lectures du Coran" },
      { key: "prayers_tracked", label: "Prières suivies" },
      { key: "hajj_pilgrims", label: "Pèlerins Hajj & Omra" },
    ],
    whatsNew: [
      "Nouveaux niveaux disponibles à l'École Coran",
      "Réservation de voyages Hajj & Omra en ligne",
      "Rappels de prière personnalisés par localisation",
    ],
    faq: [
      { q: "Les horaires sont-ils précis ?", a: "Oui, les horaires de prière sont calculés selon votre position exacte et les méthodes de calcul reconnues." },
      { q: "Comment fonctionne l'École Coran ?", a: "Un parcours structuré en 10 niveaux, de l'apprentissage des bases à la maîtrise avancée, avec l'Académie CTQIBLA à venir." },
      { q: "Puis-je réserver un voyage Hajj ou Omra ?", a: "Oui, la section Voyages vous permet de découvrir et réserver des offres Hajj & Omra encadrées." },
    ],
  },
  {
    slug: "construction",
    name: "TIRERA Construction & Habitat",
    icon: HardHat,
    iconImage: "https://static.prod-images.emergentagent.com/jobs/4bc8c93c-fa86-469a-a49a-36eba45f3ee2/images/01a1194b5bbf5d847afac18715025127c0ce966ab31121e2d07654100146a449.jpeg",
    accent: "#B45309",
    tint: "#FBF3E7",
    category: "Construction & BTP",
    type: "service",
    stores: null,
    tagline: "Construire, rénover et gérer votre habitat — devis, artisans qualifiés, matériaux et gestion immobilière, réunis dans un même écosystème.",
    image: "https://images.unsplash.com/photo-1632862378069-4ad0348cea4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    heroImage: "https://images.unsplash.com/photo-1709714398528-eb8b8df26732?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    features: [
      "Devis & construction clé en main",
      "Rénovation, extension & surélévation",
      "Artisans qualifiés & notés",
      "Vente de matériaux de construction",
      "Gestion locative de votre patrimoine",
    ],
    intro: "Un écosystème complet de la construction et de l'habitat, complémentaire de Une Maison Pour Tous : l'une pour acheter, louer et vendre, l'autre pour construire, rénover et gérer.",
    sections: [
      {
        icon: "particuliers",
        title: "Pour les particuliers",
        desc: "Votre projet de A à Z, en toute confiance.",
        items: [
          "Demander un devis de construction",
          "Construire une maison clé en main",
          "Rénover une maison",
          "Extension ou surélévation",
          "Demander un architecte",
        ],
      },
      {
        icon: "entreprises",
        title: "Pour les entreprises",
        desc: "Des ouvrages professionnels livrés dans les règles de l'art.",
        items: [
          "Construction de magasins",
          "Construction d'immeubles",
          "Construction d'entrepôts",
          "Construction de bureaux",
          "Gestion de projets",
        ],
      },
      {
        icon: "pros",
        title: "Trouver des professionnels",
        desc: "Des artisans vérifiés, près de chez vous.",
        items: [
          "Maçons",
          "Électriciens",
          "Plombiers",
          "Carreleurs",
          "Peintres",
          "Menuisiers",
          "Soudeurs",
        ],
        note: "Les artisans créent leur profil, reçoivent des demandes et sont notés par les clients.",
      },
      {
        icon: "materiaux",
        title: "Matériaux",
        desc: "Tous vos matériaux de chantier, au meilleur prix.",
        items: [
          "Ciment",
          "Fer à béton",
          "Briques",
          "Sable",
          "Carrelage",
          "Portes & fenêtres",
          "Sanitaires",
        ],
        note: "Bientôt connecté à Bon Africain pour commander vos matériaux directement.",
      },
      {
        icon: "gestion",
        title: "Gestion immobilière",
        desc: "Pilotez votre patrimoine immobilier au quotidien.",
        items: [
          "Mes appartements",
          "Mes magasins",
          "Mes locataires",
          "Paiement des loyers",
          "Contrats",
          "Entretien & maintenance",
          "Signaler une panne",
        ],
      },
    ],
  },
];

export const APPS = [..._APPS].sort((a, b) => (b.slug === "construction") - (a.slug === "construction"));

export const getApp = (slug) => APPS.find((a) => a.slug === slug);
